import { useQuery } from "@tanstack/react-query";

import { fetchTelemetry } from "../api/telemetry";

export function useTelemetry(windowHours: number = 24) {
  return useQuery({
    queryKey: ["telemetry", windowHours],
    queryFn: () => fetchTelemetry(windowHours),
    staleTime: 30_000,
    refetchInterval: 60_000,
  });
}
